module.exports = __webpack_public_path__ + "img/title-zh.72366562.png";